import { defineAsyncComponent as e } from "vue";
import { getI18n as t } from "@editor/ui-utils";
//#endregion
//#region src/lang/index.ts
var n = {
	en: {
		finanzen100ChartWidgetApi: {
			createAlreadyExists: "The stock chart widget cannot be created because another stock chart widget with this name already exists.",
			updateAlreadyExists: "Stock chart widget cannot be updated because another stock chart widget with this name already exists.",
			created: "Stock chart widget created",
			updated: "Stock chart widget updated",
			notFound: "Stock chart widget not found",
			requiredFields: "Stock chart widget cannot be saved because mandatory information is missing."
		},
		finanzen100ChartWidgetList: {
			newButton: "New stock chart widget",
			name: "Search for widget title (internal)",
			deleteFinanzen100ChartWidget: "Delete",
			dpAny: "All",
			brand: "Brand",
			instruments: "Asset name or ISIN (brand, index ...)",
			loading: "Loading stock chart widget",
			headerLabel: "Title (internal)",
			headerCreatedAt: "Creation date",
			headerChangedAt: "Last modified date",
			counter: "Counter",
			dpEdit: "Edit",
			dpView: "View",
			messageDeleted: "Message deleted",
			errorOnDeleting: "Error deleting",
			createFinanzen100ChartWidget: "Create stock chart widget"
		},
		finanzen100ChartWidget: {
			finanzen100ChartWidgetLabel: "Stock chart widget",
			backButton: "Back to stock chart widget list",
			newFinanzen100ChartWidget: "New stock chart widget",
			messageDeleteFinanzen100ChartWidget: "Delete stock chart widget",
			messageDeleteFinanzen100ChartWidgetTitle: "Are you sure you want to delete this stock chart widget?",
			deleteFinanzen100ChartWidget: "Delete",
			messageDeleted: "Stock chart widget deleted",
			errorOnDeleting: "Error deleting the stock chart widget",
			errorFailedLoadedFinanzen100ChartWidgetWithId: "Error getting the stock chart widget",
			handledInLegacySystem: "This stock chart widget is being handled in {source}. It cannot be edited in Vibe.",
			notConfiguredBrand: "The stock chart widget is not available on this brand."
		},
		finanzen100ChartWidgetEdit: {
			label: "Title (internal)",
			counter: "Counter",
			backButton: "Back to stock chart widget list",
			editFinanzen100ChartWidget: "Edit stock chart widget",
			messageSaved: "Stock chart widget saved"
		}
	},
	de: {
		finanzen100ChartWidgetApi: {
			createAlreadyExists: "Das Börsenkurs-Widget kann nicht erstellt werden, weil bereits ein Börsenkurs-Widget mit diesem Namen existiert.",
			updateAlreadyExists: "Das Börsenkurs-Widget kann nicht aktualisiert werden, weil schon ein Börsenkurs-Widget mit diesem Namen existiert.",
			created: "Börsenkurs-Widget erstellt",
			updated: "Börsenkurs-Widget aktualisiert",
			notFound: "Börsenkurs-Widget nicht gefunden",
			requiredFields: "Das Börsenkurs-Widget kann nicht gespeichert werden, weil Pflichtangaben fehlen."
		},
		finanzen100ChartWidgetList: {
			newButton: "Neues Börsenkurs-Widget",
			name: "Suchen nach Widget-Titel (intern)",
			deleteFinanzen100ChartWidget: "Löschen",
			dpAny: "Alle",
			brand: "Marke",
			instruments: "Wertpapier oder ISIN (Marke, Index …)",
			loading: "Börsenkurs-Widget wird geladen",
			headerLabel: "Titel (internal)",
			headerCreatedAt: "Erstellungsdatum",
			headerChangedAt: "Änderungsdatum (Last modified)",
			counter: "Zähler",
			dpEdit: "Bearbeiten",
			dpView: "Anzeigen",
			messageDeleted: "Nachricht gelöscht",
			errorOnDeleting: "Fehler beim Löschen",
			createFinanzen100ChartWidget: "Börsenkurs-Widget erstellen"
		},
		finanzen100ChartWidget: {
			finanzen100ChartWidgetLabel: "Börsenkurs-Widget",
			backButton: "Zurück zur Börsenkurs-Widget-Liste",
			newFinanzen100ChartWidget: "Neues Börsenkurs-Widget",
			messageDeleteFinanzen100ChartWidget: "Börsenkurs-Widget löschen",
			messageDeleteFinanzen100ChartWidgetTitle: "Willst du dieses Börsenkurs-Widget wirklich löschen?",
			deleteFinanzen100ChartWidget: "Löschen",
			messageDeleted: "Börsenkurs-Widget gelöscht",
			errorOnDeleting: "Fehler beim Löschen des Börsenkurs-Widgets",
			errorFailedLoadedFinanzen100ChartWidgetWithId: "Fehler beim Abrufen des Börsenkurs-Widgets",
			handledInLegacySystem: "Dieses Börsenkurs-Widget wird in {source} verwaltet und kann nicht in Vibe bearbeitet werden.",
			notConfiguredBrand: "Das Börsenkurs-Widget ist für diese Marke nicht verfügbar."
		},
		finanzen100ChartWidgetEdit: {
			label: "Title (internal)",
			counter: "Zähler",
			backButton: "Zurück zur Börsenkurs-Widget-Liste",
			editFinanzen100ChartWidget: "Börsenkurs-Widget bearbeiten",
			messageSaved: "Börsenkurs-Widget gespeichert"
		}
	}
}, r = [{
	path: "/finanzen-100-chart-widget",
	children: [
		{
			path: "",
			name: "finanzen_100_chart_widget_list",
			component: () => import("./finanzen-100-chart-widget-list.view-Cehk2oyF.js").then((e) => e.n),
			meta: { requiredRight: "finanzen-100-chart-widgets:navigate" }
		},
		{
			path: "new",
			name: "finanzen_100_chart_widget_new",
			component: () => import("./finanzen-100-chart-widget-edit.view-Me0w0Yk4.js").then((e) => e.n),
			props: () => ({
				title: t().t("finanzen100ChartWidget.newFinanzen100ChartWidget"),
				backRoute: "/finanzen-100-chart-widget"
			}),
			meta: { requiredRight: ["finanzen-100-chart-widgets:navigate"] }
		},
		{
			path: ":id",
			name: "finanzen_100_chart_widget_detail",
			component: () => import("./finanzen-100-chart-widget-edit.view-Me0w0Yk4.js").then((e) => e.n),
			props: (e) => ({
				title: t().t("finanzen100ChartWidgetEdit.editFinanzen100ChartWidget"),
				id: e.params.id,
				backRoute: "/finanzen-100-chart-widget"
			}),
			meta: { requiredRight: ["finanzen-100-chart-widgets:navigate"] }
		}
	]
}], i = e(() => import("./finanzen-100-chart-widget-content-block-BY19pTzM.js")), a = {
	messages: n,
	routes: r,
	contentBlocks: [{
		type: "FINANZEN_100_CHART_WIDGET",
		label: "finanzen100ChartWidget.finanzen100ChartWidgetLabel",
		icon: "insights",
		component: i,
		defaultValue: { type: "FINANZEN_100_CHART_WIDGET" }
	}]
};
//#endregion
export { i as Finanzen100ChartWidgetContentBlock, a as finanzen100ChartWidgetModule };

//# sourceMappingURL=index.es.js.map